var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D8E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.802 11.74l-2.47-2.469-9.242 9.243-3.421-3.422-2.47 2.47 4.657 4.656a1.746 1.746 0 002.47 0l10.476-10.477z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/icons/icon-check-1cff377d.svg";
export { SvgIconCheck as ReactComponent };